import React, { useContext } from 'react';
import Image from 'next/image';
import classes from './Footer.module.scss';
import t from '@/utils/Language/UI-translations';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import moment from 'moment';
import { SolutionContext } from '@/context/solution.context';
import { languageContext } from '@/context/language.context';

const Footer = () => {
  const { solution, solutionName, isPrime } = useContext(SolutionContext);
  const { currentLanguage } = useContext(languageContext);
  const logo = solution?.ui?.footer?.logo;

  const renderCookieSettings = () => {
    if (typeof window !== 'undefined' && window.OneTrust) {
      window.OneTrust.changeLanguage(currentLanguage);
      window.OneTrust.ToggleInfoDisplay();
    }
  };

  return (
    <footer className={`${classes.footer} footer`}>
      {isPrime && (
        <div className={`${classes.section} ${classes.mobileNotice} section`}>
          <ul className={`${classes.listInline}`}>
            <li className={classes.title}>
              <strong>{t('search by text')}</strong>
            </li>
            <li>{t('anyone can search')}</li>
            <li dangerouslySetInnerHTML={{ __html: t('text information') }} />
          </ul>
        </div>
      )}
      <div className={`${classes.section} ${classes.logoList} logoList section`}>
        <div className="d-none d-md-block">
          <div className={`${classes.logo} logo`}>
            {logo && (
              <a href="/">
                <Image src={logo.src} width={logo.width} height={logo.height} alt={t(logo.alt)} />
              </a>
            )}
          </div>
        </div>
        {isPrime && (
          <ul className={`${classes.listInline}`}>
            <li>
              <a href="https://about.1degree.org/"> {t('about')}</a>
            </li>
            <li>
              <a href="/organizations">{t('add Information')}</a>
            </li>
            <li>
              <a href="https://help.1degree.org/">{t('help')}</a>
            </li>
            <li>
              <a className={classes.listInlineLink} onClick={renderCookieSettings}>
                {t('Cookies Settings')}
              </a>
            </li>
            <li>
              <a href="https://about.1degree.org/release-notes/">{t('release notes')}</a>
            </li>
            <li>
              <a href="https://about.1degree.org/donate">{t('donate')}</a>
            </li>
            <li>
              <a href="https://about.1degree.org/latest-news/" target="_blank" rel="noreferrer">
                {t('blog')}
              </a>
            </li>
          </ul>
        )}
        <div className="d-inline d-md-none">
          <hr />
        </div>
      </div>
      <div className={`${classes.section} ${classes.legalList} legalList section`}>
        <div className="d-block d-md-none">
          <div className={`${classes.logo} logo`}>
            {logo && (
              <a href="/">
                <Image src={logo.src} width={logo.width} height={logo.height} alt={t(logo.alt)} />
              </a>
            )}
          </div>
        </div>
        {isPrime ? (
          <ul className={`${classes.listInline} ${classes.right}`}>
            <li className={classes.socialIcons}>
              <a href="https://www.facebook.com/1degree.org" target="_blank" rel="noreferrer" aria-label={t('One Degree on Facebook')}>
                <FontAwesomeIcon icon={['fab', 'facebook-square']} />
              </a>
              <a href="https://twitter.com/1deg" target="_blank" rel="noreferrer" aria-label={t('One Degree on Twitter')}>
                <FontAwesomeIcon icon={['fab', 'twitter-square']} />
              </a>
              <a
                href="https://github.com/1deg/"
                className="d-inline d-md-none"
                target="_blank"
                rel="noreferrer"
                aria-label={t('One Degree on Github')}
              >
                <FontAwesomeIcon icon={['fab', 'github-square']} />
              </a>
              <a
                href="https://www.linkedin.com/company/one-degree-inc-"
                className="d-inline d-md-none"
                target="_blank"
                rel="noreferrer"
                aria-label={t('One Degree on Linkedin')}
              >
                <FontAwesomeIcon icon={['fab', 'linkedin']} />
              </a>
              <a
                href="https://instagram.com/1deg/"
                className="d-inline d-md-none"
                target="_blank"
                rel="noreferrer"
                aria-label={t('One Degree on Instagram')}
              >
                <FontAwesomeIcon icon={['fab', 'instagram-square']} />
              </a>
              <a
                href="https://www.youtube.com/user/1degorg"
                className="d-inline d-md-none"
                target="_blank"
                rel="noreferrer"
                aria-label={t('One Degree on Youtube')}
              >
                <FontAwesomeIcon icon={['fab', 'youtube-square']} />
              </a>
            </li>
            <li className={classes.notice}>{t('copyright', { year: moment(Date.now()).format('Y') })}</li>
            <li>
              <a href="https://about.1degree.org/privacy-policy" rel="noreferrer">
                {t('privacy policy')}
              </a>
            </li>
            <li className="d-inline d-md-none">
              <a href="https://about.1degree.org/community-guidelines/" rel="noreferrer">
                {t('Community Guidelines')}
              </a>
            </li>
            <li>
              <a href="https://about.1degree.org/terms-of-use" rel="noreferrer">
                {t('terms of use')}
              </a>
            </li>
          </ul>
        ) : (
          <ul className={`${classes.listInline} ${classes.right}`}>
            <li className={classes.notice}>
              {t(isPrime ? 'copyright' : 'copyright_poweredby', { name: solutionName, year: moment(Date.now()).format('Y') })}
            </li>
          </ul>
        )}
      </div>
    </footer>
  );
};

Footer.defaultProps = {};

Footer.propTypes = {};

export default Footer;
